/* eslint-disable no-extend-native */
// extend native Promise interface to fit JSSDK's Promise
// this is needed as native promises can get into JSSDK in different ways,
// like when being created in our versions of RPC (OpenStackRPC)

Promise.prototype.fail = function(handler) {
    this.catch(handler);
    return this;
};

// 'done' accepts only success handler
Promise.prototype.done = function(handler) {
    this.then(handler);
    return this;
};

// without 'always', any call to an 'async' function in our code can break JSSDK, as it returns native promise without 'always'
// don't use just 'finally' here, as 'always' acts differently - its handler accepts an argument to be passed, and acts as 'catch' hook
Promise.prototype.always = function(handler) {
    this.then(handler).catch(handler);
    return this;
};
